import { DatePicker, Input } from 'antd';
import { PickerProps } from 'antd/lib/date-picker/generatePicker';
import moment, { Moment } from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, FALLBACK_DATE_FORMAT } from 'utils/hcfaConstants';
import { FormContext } from './FormProvider';
import { toNum } from '../../helpers/toNum';

type Props = PickerProps<
  Moment & {
    status?: '' | 'warning' | 'error' | undefined;
    dropdownClassName?: string | undefined;
    popupClassName?: string | undefined;
  }
> & {
  name: string;
  idx: number;
  inputId?: string;
  value?: Moment;
  onChange: (value: any) => void;
};

const DatePickerRHF: React.FC<Props> = (props) => {
  const { name, onChange, inputId, idx, value, ...rest } = props;
  const { methodsUb } = useContext(FormContext);

  const dateFormat = (props.format as string | string[]) || DATE_FORMAT;
  const [inputValue, setInputValue] = useState('');
  const path = `42Services.${idx}.${name}` as const;
  const formValue = methodsUb.watch(path);
  //   const formValue = value;

  useEffect(() => {
    if (!formValue) {
      setInputValue('');
      return;
    }
    const dateFormat = inputValue && inputValue.length === 6 ? FALLBACK_DATE_FORMAT : DEFAULT_DATE_FORMAT;
    if (moment.isMoment(formValue) && formValue.isValid()) {
      const changedValue = moment.utc(formValue).format(dateFormat);

      if (changedValue !== inputValue) {
        setInputValue(changedValue || '');
      }
    }
  }, [formValue]);

  function onDateInputChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const value = ev.target.value;

    setInputValue(value);

    const date = moment.utc(value, dateFormat, true);

    if (path) {
      if (value) {
        onChange(date);
      } else {
        onChange(date);
      }
    }
  }

  function inputRender() {
    return (
      <Input
        id={inputId}
        //style={{ width: '70px' }}
        value={inputValue}
        placeholder={props.placeholder || ''}
        onChange={onDateInputChange}
        onBlur={(e) => {
          onDateInputChange(e);
          methodsUb.trigger(path);
        }}
        onInput={toNum}
      />
    );
  }
  return <DatePicker allowClear={false} {...rest} inputRender={inputRender} />;
};

export default DatePickerRHF;
